import axios from 'axios'
import { dispatch, getState } from 'lib/store'
import log from 'lib/log'
// import localStorage from 'lib/local-storage'
// import { getState } from 'lib/store'
// import initState from 'lib/init-state'
import env from 'config/env'
import {
  SET_USER_TOKEN,
  SET_USERNAME,
  SET_FETCHING_LOGIN,
  SET_LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
  LOGOUT,
  RESET_STATE,
} from 'constants/action-types'
import { API_LOGIN_URL } from 'constants/auth'
import initState from 'lib/init-state'
import { isDemoMode } from 'lib/is-demo'
import browserSessionId from 'lib/browser-sessionId'
import { addAttributeValueFilter } from 'actions/search/filters'

interface LoginResponse {
  token: string
}

/**
 * Login user with username and password
 */
export const login = async (
  username: string,
  password: string,
  navigate: (path: string) => void,
): Promise<void> => {
  dispatch(SET_FETCHING_LOGIN, true)
  dispatch(CLEAR_LOGIN_ERROR)

  try {
    const response = await axios.post<LoginResponse>(
      `${env.API_URL}${API_LOGIN_URL}`,
      {
        username,
        password,
      },
    )

    const token = response.data.token

    // Save token and username to Redux state
    dispatch(SET_USER_TOKEN, token)
    dispatch(SET_USERNAME, username)

    // In demo mode, add browserSessionId filter before navigation
    // so it's in the store when Search mounts and fires initial fetches
    if (isDemoMode) {
      addAttributeValueFilter('params.browserSessionId', browserSessionId)
    }

    // Navigate to home page
    navigate('/')
  } catch (error: unknown) {
    let loginError = 'An error occurred during login'

    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401) {
        loginError = 'Invalid username or password'
      } else if (!error.response) {
        loginError = 'Connection error. Please check your network.'
      } else {
        loginError =
          error.response?.data?.message || error.message || loginError
      }
    }

    dispatch(SET_LOGIN_ERROR, loginError)
  } finally {
    dispatch(SET_FETCHING_LOGIN, false)
  }
}

/**
 * Logout user
 *  - remove token from state and local storage
 *  - reset application state
 *  - navigate to login page
 */
export const logout = (): void => {
  log.info('Logout')
  // Clear token first so ProtectedRoute unmounts everything
  dispatch(LOGOUT)
  // Reset the application state (token already cleared, so initState won't preserve auth)
  localStorage.removeItem('state')
  const newState = initState(getState())
  dispatch(RESET_STATE, newState)
}

/**
 * Clear login error
 */
export const clearLoginError = (): void => {
  dispatch(CLEAR_LOGIN_ERROR)
}
